import { useSelector } from 'react-redux'
import useRoles from '@/hooks/useRoles'

const useTeacherCanInitiateChat = () => {
  const { isSeminarian } = useRoles()
  const isInitiationDisabled = useSelector(
    (store) => store.settings.isTeachersCannotInitiateDialogues === '1',
  )

  return !isSeminarian || !isInitiationDisabled
}

export default useTeacherCanInitiateChat
